
















































































import axios from 'axios';
import env from '@/env';
import { Component, Vue } from 'vue-property-decorator';
import MatrixLegend from '@/components/Matrix/MatrixLegend.vue';
import { Module } from '@/interfaces/Module';
import { Step } from '@/interfaces/Step';

@Component({
  components: { MatrixLegend },
  computed: {
    allCutoverplanCrossEnvironments() {
      const cross: any[] = [];
      this.$store.state.all_cutoverplans.forEach((cutoverplan: any) => {
        this.$store.state.all_environments.forEach((environment: any) => {
          cross.push({ cutoverplan, environment });
        });
      });
      return cross;
    }
  }
})
export default class MatrixView extends Vue {
  blueprints = Array;

  attributesByBlueprintId: any = {};

  allAttributesOfBlueprints: any[] = [];

  fullCutoverplansById: any = {};

  tableReady = true;

  async created() {
    this.$emit('showPreloader');
    const { data } = await axios.get(`${env.backend_url}/matrix`);
    this.allAttributesOfBlueprints = data.module.map((module: Module) => [
      ...module.attributes,
      ...module.steps.map((step: Step) => step.attributes)
    ]);
    this.$emit('loadingFinished');
  }

  getTableString(cutoverplan: any, environment: any, attribute: any): string {
    const attributeInCutoverplanAndItsSteps: any[] = [];

    function onlyNotAlreadyIncluded(attributeInModule: any) {
      return !attributeInCutoverplanAndItsSteps.find(
        (attr: any) => attr.id === attributeInModule.id
      );
    }

    cutoverplan.modules.forEach((module: any) => {
      attributeInCutoverplanAndItsSteps.push(...module.attributes.filter(onlyNotAlreadyIncluded));
    });
    const attributeExists = Object.values(attribute).length > 1;

    const cutoverplanHasBlueprint = cutoverplan.modules.find(
      (module: any) => module.blueprint_id === attribute.origin_id
    );
    if (!cutoverplanHasBlueprint) return ' ';
    if (cutoverplanHasBlueprint && !attributeExists) return '∅ Attr';

    cutoverplan.modules.forEach((module: any) => {
      module.steps.forEach((step: any) => {
        if (step.attributes.length > 0) {
          attributeInCutoverplanAndItsSteps.push(...step.attributes.filter(onlyNotAlreadyIncluded));
        }
      });
    });

    const cutoverplanSpecifiedAttribute = attributeInCutoverplanAndItsSteps.find(
      (attr: any) => attr.blueprint_id === attribute.id
    );

    const attributeSpecifiedForEnvironment =
      cutoverplanSpecifiedAttribute?.environments[environment.id];

    // if (attributeSpecifiedForEnvironment?.value_txt) return '✓✓✓'; // speziell für environment festgelegt
    if (attributeSpecifiedForEnvironment?.value_txt)
      return attributeSpecifiedForEnvironment.value_txt; // speziell für environment festgelegt
    if (cutoverplanSpecifiedAttribute?.value_txt) return cutoverplanSpecifiedAttribute.value_txt; // nur generell, nicht speziell für env festgelegt (wird als fallback benutzt)
    return 'X';
  }
}
